export type NearbyCamerasRequestType = "all" | string;

export type NearbyCamerasRequest = {
  latitude: number;
  longitude: number;
  type: NearbyCamerasRequestType;
};

export type NearbyCamera = {
  id: string;
  name: string;
  distanceMeters: number | null;
  sourceType: string | null;
  cam360Rtsp: string | null;
  ptzRtsp: string | null;
  rank: number;
};

export type NearbyCamerasResponse = {
  cameras: NearbyCamera[];
};

export type SnapshotResponse = {
  blob: Blob;
  objectUrl: string;
};

export type NearbyCameraSource = {
  id: string;
  name?: string | null;
  cam360Rtsp?: string | null;
  ptzRtsp?: string | null;
  distanceMeters?: number | null;
  sourceType?: string | null;
  rank?: number;
};

export function toNearbyCamera(camera: NearbyCameraSource): NearbyCamera {
  return {
    id: String(camera.id ?? "").trim(),
    name: String(camera.name ?? "Camera").trim() || String(camera.id ?? "Camera"),
    distanceMeters: camera.distanceMeters ?? null,
    sourceType: camera.sourceType ?? null,
    cam360Rtsp: camera.cam360Rtsp?.trim() || null,
    ptzRtsp: camera.ptzRtsp?.trim() || null,
    rank: camera.rank ?? 0,
  };
}
